export default __webpack_public_path__ + "9bc57edd6415a8f4eff52a367348dbeb.svg";